import { render, staticRenderFns } from "./ProcessQuestionWithPoint.vue?vue&type=template&id=5ba84d24"
import script from "./ProcessQuestionWithPoint.vue?vue&type=script&lang=js"
export * from "./ProcessQuestionWithPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports